import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3403, { U3403ROLES } from './U3403';
import U3403StandaloneScreen from './components/U3403StandaloneScreen';

const U3403Routes: RouteObject[] = [
  {
    path: 'U3403',
    element: <U2000RequireRole allowedRoles={[U3403ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3403 />,
        children: [{ index: true, element: <U3403StandaloneScreen /> }],
      },
    ],
  },
];

export default U3403Routes;
